import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { FilterUserStatusOption } from 'src/core/models'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { usersAdminFilterStatusSelector, setAdminUsersFilterStatusOption } from 'src/features'

const filterOptions = {
  ALL: 'ALL',
  VALIDATED: 'validated',
  NON_VALIDATE: 'no_validated',
  REJECTED: 'rejected'
}

const FilterUserByStatus: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const selectedFilter = useAppSelector(usersAdminFilterStatusSelector)
  const { width } = useWindowSize()
  const isMobile = width <= 800

  const handleChange = (value: FilterUserStatusOption) => {
    dispatch(setAdminUsersFilterStatusOption(value))
  }

  return (
    <Select
      value={selectedFilter}
      onChange={handleChange}
      style={{ width: isMobile ? '100%' : '90%' }}
      className={isMobile && 'mb-2'}
    >
      <Select.Option value={filterOptions.ALL}>{t('Validate.AllStatus')}</Select.Option>
      <Select.Option value={filterOptions.VALIDATED}>{t('Validate.Validated')}</Select.Option>
      <Select.Option value={filterOptions.NON_VALIDATE}>{t('Validate.NonValidated')}</Select.Option>
      <Select.Option value={filterOptions.REJECTED}>{t('Validate.Rejected')}</Select.Option>
    </ Select>
  )
}

export default FilterUserByStatus
